import React, {Component} from 'react';
import {connect} from 'react-redux';
import setChatState from '../../actions/chat/setChatState';
import fetchChatNewMessages from '../../actions/chat/fetchChatNewMessages';
import { inject, observer } from 'mobx-react';
import { reaction, toJS } from 'mobx';

class ChatButton extends Component {
  constructor(props) {
    super(props);
    reaction(()=>{
      return this.props.chatStore.ws_cmd.timestamp
    },()=>{
      const cmd=toJS(this.props.chatStore.ws_cmd);
      if(cmd.message==='new_messages') {
        if (this.props.chatStore.opened_windows.indexOf(parseInt(cmd.chat_id)) === -1) {
          this.props.chatStore.fetchNewMessages();
        }
      }
    });
  }
  componentDidMount() {
    if(this.props.meStore.me.data) {
      this.props.chatStore.fetchNewMessages();
    }
  }
  /*
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.me && !prevProps.me) {
      this.props.fetchChatNewMessages();
    }
    if (this.props.chat_ws && (!prevProps.chat_ws && this.props.chat_ws || (prevProps.chat_ws.timestamp !== this.props.chat_ws.timestamp))) {
      if (this.props.chat_ws.message === 'new_messages') {
        if (this.props.chat_opened_windows.indexOf(parseInt(this.props.chat_ws.chat_id)) === -1) {
          this.props.fetchChatNewMessages();
        }
      }
    }
  }
  */
  renderNewMessages() {
    if(this.props.chatStore.new_messages.data && this.props.chatStore.new_messages.data.length>0) {
      const len=this.props.chatStore.new_messages.data.length;
      return (
        <div className="pa pa-tr bg-const2 w1 fs13 rad200 mtop10 mright10" style={{width:15,height:15}}>
          {len}
        </div>
      )
    }
    return null;
  }
  render() {
    if(!this.props.meStore.me.data) {
      return null;
    }
    return (
      <div className={`dib tac menuSquare pointer pr only-s-dn`} onClick={()=>{ this.props.chatStore.float_window=this.props.chatStore.float_window?null:'contacts_list'; }}>
        <div className="up12 splice h100">
          <div className="cell s-middle s-auto">
            <i className="mdi mdi-comment-outline fs30 "></i>
          </div>
        </div>
        {this.renderNewMessages()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    chat_state:state.chat_state,
    me:state.me,
    chat_new_messages: state.chat_new_messages,
    chat_ws:state.chat_ws,
    chat_opened_windows:state.chat_opened_windows,
  }
}

// export default connect(mapStateToProps,{ setChatState, fetchChatNewMessages })(ChatButton);
export default inject("meStore","chatStore")(observer(ChatButton));